export const supportInitialState = {
  tickets: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  ticket: {
    data: [],
    loading: false,
    error: null,
  },
  replyTicket: {
    loading: false,
    error: null,
  },
  addTicket: {
    loading: false,
    error: null,
  },
  closeTicket: {
    loading: false,
    error: null,
  },
  categories: {
    data: [],
    loading: false,
    error: null,
  },
  removeCategories: {
    loading: false,
    error: null,
  },
  addCategory: {
    loading: false,
    error: null,
  },
  editCategory: {
    loading: false,
    error: null,
  },
  selectedCategory: {},
};
